import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
// import type { GlobalToken } from 'antd/es/theme'

export interface ThemeState {
  theme: "dark" | "light";
  layout: "side" | "mix";
  mode: "vertical" | "inline" | "horizontal";
  width: string;
  height: string;
  collapsed: boolean;
  collapsedWidth: string;
  headerTheme: boolean;
  showBreadcrumb: boolean;
  token: Partial<any>;
  algorithm: string;
}

const initialState: ThemeState = {
  theme: "light", // light, dark
  layout: "mix", // side, mix
  mode: "inline",
  width: "180px",
  height: "70px",
  collapsed: false,
  collapsedWidth: "80px",
  headerTheme: false,
  showBreadcrumb: true, // 是否显示面包屑
  token: {
    // primaryColor: "#0275FF",
    // textColor: 'red',
    // black: 'red'
    // textColorSecondary: 'red',
    // headingColor: 'red',
    // black: 'red'
    // linkColor: 'pink',
    // warningColor: 'pink',
    // colorInfo: '#0077fa',
  },
  algorithm: "defaultAlgorithm",
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme(state: ThemeState, action: PayloadAction<Partial<ThemeState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setTheme } = themeSlice.actions;

export default themeSlice.reducer;
